"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jarFilesToScannedProjects = void 0;
const admzip = require("adm-zip");
const path = require("path");
const buffer_utils_1 = require("../../buffer-utils");
function groupJarFingerprintsByPath(input) {
    const jarFingerprints = Object.entries(input).map(([filePath, digest]) => {
        return {
            location: filePath,
            digest,
        };
    });
    const resultAggregatedByPath = jarFingerprints.reduce((jarsAggregatedByPath, jarFingerprint) => {
        const location = path.dirname(jarFingerprint.location);
        jarsAggregatedByPath[location] = jarsAggregatedByPath[location] || [];
        jarsAggregatedByPath[location].push(jarFingerprint);
        return jarsAggregatedByPath;
    }, {});
    return resultAggregatedByPath;
}
async function jarFilesToScannedProjects(filePathToContent, targetImage, shadedJars) {
    const mappedResult = groupJarFingerprintsByPath(filePathToContent);
    const scanResults = [];
    for (const path in mappedResult) {
        if (!mappedResult.hasOwnProperty(path)) {
            continue;
        }
        let getJarFingerprints = getJarSha;
        if (shadedJars) {
            getJarFingerprints = checkIfFatJarsAndUnpack;
        }
        const jarFingerprintsFact = {
            type: "jarFingerprints",
            data: {
                fingerprints: getJarFingerprints(mappedResult[path]),
                origin: targetImage,
                path,
            },
        };
        scanResults.push({
            facts: [jarFingerprintsFact],
            identity: {
                type: "maven",
                targetFile: path,
            },
        });
    }
    return scanResults;
}
exports.jarFilesToScannedProjects = jarFilesToScannedProjects;
function getJarSha(jarBuffers) {
    return jarBuffers.map((element) => {
        return Object.assign(Object.assign({}, element), { digest: buffer_utils_1.bufferToSha1(element.digest) });
    });
}
function checkIfFatJarsAndUnpack(jarBuffers) {
    const fingerprints = [];
    for (const jarBuffer of jarBuffers) {
        const nestedJars = [];
        const buffer = jarBuffer.digest;
        const zip = new admzip(buffer);
        const zipEntries = zip.getEntries();
        for (const zipEntry of zipEntries) {
            if (zipEntry.entryName.endsWith(".jar")) {
                nestedJars.push({
                    location: zipEntry.entryName,
                    digest: zipEntry.getData(),
                });
            }
        }
        if (nestedJars.length > 0) {
            fingerprints.push(...nestedJars.map((element) => {
                return Object.assign(Object.assign({}, element), { digest: buffer_utils_1.bufferToSha1(element.digest) });
            }));
        }
        else {
            fingerprints.push({
                location: jarBuffer.location,
                digest: buffer_utils_1.bufferToSha1(jarBuffer.digest),
            });
        }
    }
    return fingerprints;
}
//# sourceMappingURL=java.js.map